var Seat = /** @class */ (function () {
    function Seat(props) {
        this.onlyHandicapped = false;
        this.status = Status.Idle;
        Object.assign(this, props);
    }
    return Seat;
}());
export { Seat };
var SeatZone = /** @class */ (function () {
    function SeatZone(props) {
        this.size = { width: 200, height: 200 };
        this.backgroundColor = '#f0f0f0';
        this.fontColor = '#00ff00';
        Object.assign(this, props);
    }
    return SeatZone;
}());
export { SeatZone };
var MapSite = /** @class */ (function () {
    function MapSite() {
    }
    return MapSite;
}());
export { MapSite };
export var Status;
(function (Status) {
    Status["Idle"] = "idle";
    Status["Reserved"] = "reserved";
    Status["Selected"] = "selected";
    Status["Disabled"] = "disabled";
})(Status || (Status = {}));
export var Numeration;
(function (Numeration) {
    Numeration["Sequent"] = "sequent";
    Numeration["Pair"] = "pair";
    Numeration["Odd"] = "odd";
})(Numeration || (Numeration = {}));
export var DirectionNumeration;
(function (DirectionNumeration) {
    DirectionNumeration["Right"] = "right";
    DirectionNumeration["Left"] = "left";
})(DirectionNumeration || (DirectionNumeration = {}));



//////////////////
// WEBPACK FOOTER
// ./src/modules/SeatingAreas/Model.ts
// module id = 137
// module chunks = 0